// Collapsible content rows: animated open and close, and only one row open per page,
// across every collapsible content section. Without this script the rows keep the
// native <details> behaviour.
if (!customElements.get('collapsible-rows')) {
  const OPEN_DURATION_MS = 280;
  const CLOSE_DURATION_MS = 220;
  const EASING = 'cubic-bezier(0.2, 0, 0, 1)';
  const ROW_SELECTOR = 'collapsible-rows details';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class CollapsibleRows extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onSummaryClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onSummaryClick);
    }

    onSummaryClick = (event) => {
      const summary = event.target.closest('summary');
      if (!summary || !this.contains(summary)) return;

      const details = summary.parentElement;
      event.preventDefault();

      if (details.open && !details.dataset.closing) {
        collapse(details);
        return;
      }

      document.querySelectorAll(`${ROW_SELECTOR}[open]`).forEach((other) => {
        if (other !== details) collapse(other);
      });
      expand(details);
    };
  }

  function summaryHeight(details) {
    return details.querySelector('summary').offsetHeight;
  }

  function animateHeight(details, from, to, duration, onFinish) {
    details.rowAnimation?.cancel();
    const content = details.querySelector('.accordion__content');

    details.style.overflow = 'hidden';
    details.rowAnimation = details.animate(
      { height: [`${from}px`, `${to}px`] },
      { duration, easing: EASING }
    );
    content?.animate({ opacity: to > from ? [0, 1] : [1, 0] }, { duration, easing: EASING });

    details.rowAnimation.onfinish = () => {
      details.rowAnimation = null;
      details.style.overflow = '';
      onFinish?.();
    };
  }

  function expand(details) {
    delete details.dataset.closing;
    if (reducedMotion.matches) {
      details.open = true;
      return;
    }
    const from = details.open ? details.offsetHeight : summaryHeight(details);
    details.open = true;
    animateHeight(details, from, details.scrollHeight, OPEN_DURATION_MS);
  }

  function collapse(details) {
    if (reducedMotion.matches) {
      details.open = false;
      return;
    }
    details.dataset.closing = 'true';
    animateHeight(details, details.offsetHeight, summaryHeight(details), CLOSE_DURATION_MS, () => {
      details.open = false;
      delete details.dataset.closing;
    });
  }

  customElements.define('collapsible-rows', CollapsibleRows);
}
